/**
 * User agent sniffer :(
 * They made me do it! I swear :(...
 */
import UAParser from 'ua-parser-js'
import { makeSafeFn } from './fn'
import { registerUtils } from '../application/nm'
import { queryString } from './window'
import { create as makeEmptyObj } from './object'

let parser = new UAParser()
parser.setUA(navigator.userAgent)
export let parserResult = parser.getResult()

// based on domain elevation
export function domainFromFqdn() {
  return document.domain.split('.')[0] || '90min'
}

const PAGE_LAYOUTS = {
  EMBED: {
    PATH: 'embed',
    INDEXES: [0, 1],
  },
  SYND: {
    PATH: 'synd',
    INDEXES: [0, 1],
  },
  HYBRID: {
    PATH: 'hybrid',
    INDEXES: [0, 1],
  },
  NATIVE: {
    PATH: 'native',
    INDEXES: [0, 1],
  },
  DRAFT: {
    PATH: 'drafts',
    INDEXES: [0, 1],
  },
  TEST: {
    PATH: 'test',
    INDEXES: [0],
  },
}

const USER_AGENTS = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  IOS: 'iOS',
  ANDROID: 'Android',
}

export const PLATFORMS = {
  DESKTOP: 'desktop',
  MOBILE_WEB: 'mobile web',
  NATIVE_APP: 'native app',
}

export const DEVICE_MODELS = {
  NEXUS_6: 'Nexus 6',
}

export const BROWSER_NAMES = {
  CHROME: 'Chrome',
  SAFARI: 'Safari',
}

const BROWSER_PN_SUPORTIVE_VERSIONS = {
  CHROME: 42,
}

function isPageLayoutByName(pathnameParts, layout) {
  let indexOfLayoutName = pathnameParts.indexOf(layout.PATH)
  return makeSafeFn(function getLayoutName() {
    return (layout && layout.INDEXES.includes(indexOfLayoutName)) || false
  }).invoke()
}

function addScreenCoverElementAndReturnHeight() {
  const coverElementId = 'cover-element'
  const element = document.getElementById(coverElementId)
  if (!element) {
    const coverElement = document.createElement('div')
    coverElement.id = coverElementId
    Object.assign(coverElement.style, {
      position: 'absolute',
      'z-index': '-9999',
      height: '100vh',
      width: '100vw',
      top: '0',
      right: '0',
      left: '0',
      bottom: '0',
    })
    ;(document.body.append && document.body.append(coverElement)) ||
      document.body.appendChild(coverElement)
    return document.getElementById(coverElementId).clientHeight
  }
  return element.clientHeight
}

export const BREAKPOINTS = {
  TABLET: {
    LANDSCAPE: 1e3,
    PORTRAIT: 768,
  },
  DESKTOP: 1024,
}

export const viewport = {
  // add comment about shy we userd the following:
  get width() {
    return 'orientation' in screen ? window.innerWidth : document.body.scrollWidth
  },
  get height() {
    return 'orientation' in screen ? window.innerHeight : addScreenCoverElementAndReturnHeight()
  },
  get isPortrait() {
    return this.height > this.width
  },
  get orientation() {
    return this.isPortrait ? 'portrait' : 'landscape'
  },
  get widerThanTabletBreakpoint() {
    return this.width >= BREAKPOINTS.TABLET.LANDSCAPE
  },
  get narrowrThanTabletBreakpoint() {
    return this.width <= BREAKPOINTS.TABLET.LANDSCAPE
  },
}

export function getDomainFromFqdn() {
  return domainFromFqdn()
}

export function getIsTabletSize() {
  const orientationScale = viewport.isPortrait ? viewport.width : viewport.height
  return orientationScale >= BREAKPOINTS.TABLET.PORTRAIT && orientationScale < BREAKPOINTS.DESKTOP
}

export function getIsDesktop() {
  return parserResult.device.type === undefined && !getIsMobileOs()
}

export function getIsMobile() {
  return parserResult.device.type === USER_AGENTS.MOBILE || (!getIsTabletSize() && getIsMobileOs())
}

export function getIsTablet() {
  return parserResult.device.type === USER_AGENTS.TABLET || (getIsTabletSize() && getIsMobileOs())
}

export function getIsTabletInPortrait() {
  return getIsTablet() && viewport.isPortrait
}

export function getIsMobileOrTablet() {
  return getIsMobile() || getIsTablet()
}

export function getIsAndroid() {
  return parserResult.os.name === USER_AGENTS.ANDROID
}

export function getIsIos() {
  return parserResult.os.name === USER_AGENTS.IOS
}

export function getIsBot() {
  return !!parserResult.ua.match(/bot/i)
}
export function getIsMobileOs() {
  return getIsIos() || getIsAndroid()
}
export function getBrowserClassName() {
  return parserResult.browser.name.toLowerCase().split(' ').join('-')
}

export function getIsSafari() {
  return parserResult.browser.name === BROWSER_NAMES.SAFARI
}

export function getIsIe() {
  return parserResult.browser.name === 'IE'
}

export function getIsFacebookApp() {
  return /FBAV\/([\w\.]+);/i.test(navigator.userAgent)
}

export function getDoesSupportPns() {
  return (
    parserResult.browser.name === BROWSER_NAMES.CHROME &&
    parseInt(parserResult.browser.major, 10) >= BROWSER_PN_SUPORTIVE_VERSIONS.CHROME
  )
}

export function getPlatform() {
  return getIsDesktop()
    ? PLATFORMS.DESKTOP
    : getIsNativeApp() ? PLATFORMS.NATIVE_APP : PLATFORMS.MOBILE_WEB
}

export function getFormFactor() {
  return getIsDesktop()
    ? PLATFORMS.DESKTOP
    : getIsTablet() ? USER_AGENTS.TABLET : USER_AGENTS.MOBILE
}
// This can be determined by the post layout, but then we have a problem of backwards compatibility.
export function getIsNativeApp() {
  return !!queryString.app || path.isNative || path.isHybrid
}
export const isInIframe = (function detectIframe() {
  try {
    return window.self !== window.top
  } catch (ex) {
    return true
  }
})()

export const path = makeEmptyObj({
  get parts() {
    return window.location.pathname.substr(1).split('/')
  },
  isLayoutByName(layout) {
    return isPageLayoutByName(this.parts, layout)
  },
  get isEmbedded() {
    return this.isLayoutByName(PAGE_LAYOUTS.EMBED)
  },
  get isSyndication() {
    return this.isLayoutByName(PAGE_LAYOUTS.SYND)
  },
  get isHybrid() {
    return this.isLayoutByName(PAGE_LAYOUTS.HYBRID)
  },
  get isNative() {
    return this.isLayoutByName(PAGE_LAYOUTS.NATIVE)
  },
  get isDraft() {
    return this.isLayoutByName(PAGE_LAYOUTS.DRAFT)
  },
  get isKitchenSink() {
    return this.isLayoutByName(PAGE_LAYOUTS.KITCHEN_SINK)
  },
  get isFullLayout() {
    return !this.isEmbedded && !userAgent.isNativeApp
  },
})

export function isPlatform(platform) {
  if (platform === 'desktop') {
    return getIsDesktop()
  }
  if (platform === 'mobile') {
    return getIsMobile()
  }
  return parserResult.device.type === platform
}

let userAgent = {
  BREAKPOINTS,
  PLATFORMS,
  DEVICE_MODELS,
  BROWSER_NAMES,
  viewport,
  getDomainFromFqdn,
  getIsTabletSize,
  getIsDesktop,
  getIsMobile,
  getIsTablet,
  getIsTabletInPortrait,
  getIsMobileOrTablet,
  getIsAndroid,
  getIsIos,
  getIsBot,
  getIsMobileOs,
  getBrowserClassName,
  getIsSafari,
  getIsIe,
  getIsFacebookApp,
  getDoesSupportPns,
  getPlatform,
  getFormFactor,
  getIsNativeApp,
  path,
}

Object.assign(userAgent, parserResult, {
  isPlatform,
})

registerUtils({ userAgent })

//export default userAgent;



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/ua.js